import styled from "styled-components";


export const SelectTypes = styled.select`

    background-color:#EFEFEF ;
    margin-left: 1rem;

`

